import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/forward.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/images/aboutoverlay.webp");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/About/Team.js");
